import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #008ecc;
    --accent-color: #008ecc;
    --text-color: #000000;
    --text-dark: #008ecc;
    --primary-light: rgba(0, 142, 204, 0.1);
    --background-color: #FFFFFF;
    --footer-bg-color: #F5F5F5;
  }

  body {
    background-color: var(--background-color);
    color: var(--text-color);
    font-family: 'Barlow', sans-serif;
  }

  .btn-primary {
    background-color: var(--primary-color);
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .btn-primary:hover {
    background-color: #006e9f;
  }

  a.primary-link {
    color: var(--primary-color);
    text-decoration: none;
    transition: color 0.3s ease;
  }

  a.primary-link:hover {
    color: #006e9f;
  }

  .highlight-text {
    color: var(--primary-color);
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  /* Common styling for buttons */
  button, .button {
    cursor: pointer;
    font-family: 'Barlow', sans-serif;
  }

  /* Primary button styling */
  .btn-primary, .button.primary {
    background-color: var(--primary-color);
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 20px;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-primary:hover, .button.primary:hover {
    background-color: #006e9f;
  }

  /* Container class for consistent spacing */
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  /* Section styling */
  section {
    padding: 0.4rem 0;
  }

  /* Heading styles */
  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    font-weight: 600;
    line-height: 1.3;
  }

  /* Hero section styling */
  .hero-section {
    position: relative;
    min-height: 70vh;
    display: flex;
    align-items: center;
  }
`;

export default GlobalStyles; 